/**
 * CustomFieldTypeManagementPage Route Component
 *
 * Page component integrating CustomFieldTypeManagement
 */

import React from "react";
import CustomFieldTypeManagement from "../components/analyzers/admin/CustomFieldTypeManagement";

const CustomFieldTypeManagementPage = () => {
  return <CustomFieldTypeManagement />;
};

export default CustomFieldTypeManagementPage;
